import PropertyStream from 'pw-property-stream'
import {facadeStreamSetter, useStateStream} from './streamUtil.js'
import MapStream from 'pw-map-stream'

const createObjectKey = (type, id) => `${type}:${id}`
const hookOptions = {endStream: true}

export default class DevicePreviewStreams {
  constructor (events, routeStream) {
    this.initialized = false
    events.once('init', this.init.bind(this))
    this.bufferedRequests = new Map()
    this.currentStreams = new Map()
  }

  init (namePrefix, streamingClient) {
    this.initialized = true
    this.namePrefix = namePrefix
    this.streamingClient = streamingClient
    for (const {type, id, output} of this.bufferedRequests.values()) {
      this._createAndPipeStream(type, id, output)
    }
    this.bufferedRequests = new Map()
  }

  _createAndPipeStream (type, id, output) {
    const key = createObjectKey(type, id)
    const cachedStreams = this.currentStreams.get(key)
    let stream, rootOutput
    if (cachedStreams) {
      stream = cachedStreams.stream
      rootOutput = cachedStreams.rootOutput
    } else {
      stream = this.streamingClient.create({
        path: 'immersive/object-viewer',
        name: `${this.namePrefix}domain-object:${key}`,
        options: {type, id}
      })
      rootOutput = new PropertyStream({isLoading: true, type, id, data: null, error: null})
      stream
        .pipe(MapStream(d => ({isLoading: false, type, id, data: d.data, error: d.error})))
        .pipe(rootOutput)
      this.currentStreams.set(key, {stream, rootOutput})
    }

    rootOutput.pipe(output)
    output.once('end', () => {
      this.bufferedRequests.delete(output)
      if (rootOutput._readableState.pipesCount === 0) {
        stream.destroy()
        this.currentStreams.delete(key)
      }
    })
  }

  getStream (type, id) {
    const output = new PropertyStream()
    if (!this.streamingClient) {
      this.bufferedRequests.set(output, {type, id, output})
    } else {
      this._createAndPipeStream(type, id, output)
    }
    return output
  }

  getSetter (context, property, type, id) {
    const stream = this.getStream(type, id)
    return facadeStreamSetter(stream, context, property, hookOptions)
  }

  useHook (type, id) {
    const stream = this.getStream(type, id)
    return useStateStream(stream, undefined, hookOptions)
  }
}
